import { StyledComponentProps } from '../../Types'
import { StyledStars } from './styles'

export type StyledStarsProps = StyledComponentProps<typeof StyledStars>

export const ratingArr = [0, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5] as const
export type Rating = (typeof ratingArr)[number]

export const ratingFromNumber = (num: number): Rating => {
    if (num > 5) return ratingArr[9]
    if (num <= 0.5) return ratingArr[0]
    return (Math.round(num * 2) / 2) as Rating
}

export interface StarsProps extends StyledStarsProps {
    rating: number
}
